'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/StarFull.tsx
var SvgStarFull = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M11.462 2.001a1.25 1.25 0 0 1 1.076 0c.284.136.447.374.54.526.096.156.195.357.299.568l2.2 4.456.011.024.026.004 4.92.719c.233.034.455.066.633.109.173.042.45.123.666.352.26.273.381.65.332 1.023-.041.312-.218.54-.333.676-.119.139-.28.295-.448.46l-3.56 3.466-.018.018.004.026.84 4.896c.04.232.078.453.092.635.014.178.023.467-.128.744-.18.33-.5.563-.87.632-.31.057-.582-.04-.746-.108a7.57 7.57 0 0 1-.576-.284l-4.399-2.313-.023-.013-.023.013-4.399 2.313a7.58 7.58 0 0 1-.576.284c-.164.068-.436.165-.746.108a1.25 1.25 0 0 1-.87-.633c-.15-.276-.142-.565-.128-.743.014-.181.052-.403.092-.635l.84-4.896.004-.026-.019-.018-3.538-3.446-.02-.02a7.621 7.621 0 0 1-.449-.46c-.115-.135-.292-.364-.333-.676a1.25 1.25 0 0 1 .332-1.023c.216-.229.493-.31.666-.352.178-.043.4-.075.632-.11l.03-.003 4.89-.715.027-.004.011-.024 2.2-4.456c.104-.21.204-.412.299-.568.093-.152.256-.39.54-.526Z" }));
var StarFull_default = SvgStarFull;

module.exports = StarFull_default;
